import {MutationTree} from "vuex";
import * as moment from "moment";
import SubPanel from "../ts/SubPanel";
import ApiClient from "../../PanelSettings/ts/ApiClient";

export const mutations: MutationTree<any> = {
    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setSaving(state: any, payload: boolean) {
        state.saving = payload;
    },

    setUploading(state: any, payload: boolean) {
        state.uploading = payload;
    },

    setData(state: any, payload: Array<SubPanel>) {
        state.subPanels = payload;
        state.expires = moment().add(15, 'minutes');
    },

    setSubPanelTranslations(state: any, payload: Array<any>) {
        state.subPanelTranslations = payload;
    },

    delete(state: any, id: number) {
        let index = state.subPanels.findIndex( (sp: SubPanel) => {
            return sp.id == id;
        });
        state.subPanels.splice(index, 1);
    },

    create(state: any, subPanel: SubPanel) {

        state.subPanels.push(subPanel);
    },

    update(state: any, subPanel: SubPanel) {

        let found = state.subPanels.find( (sp: SubPanel) => {
            return sp.id === subPanel.id;
        });

        found = Object.assign(found,subPanel);
    },

    setApiClients(state: any, payload: any) {
        state.apiClients = payload;
    },

    addApiClient(state: any, payload: any) {
        state.apiClients.push(payload);
    },

    deleteApiClient(state: any, id: number) {
        const index = state.apiClients.findIndex((client: ApiClient) => client.id === id);
        state.apiClients.splice(index, 1);
    },

    clearApiClients(state: any) {
        state.apiClients = [];
    },

    enableRegistrationSurvey(state: any, payload: any) {
        let found = state.subPanels.find((subPanel: SubPanel) => subPanel.id === payload.sub_panel_id);
        found.registration_survey = payload;
    },
};
